import { UserManager } from "oidc-client-ts";
import config from "../../config/oAuthConfig";

export const oidcManager = new UserManager({
  authority: config.oauthServerUrl,
  client_id: config.clientId,
  redirect_uri: window.location.origin + "/callback",
  post_logout_redirect_uri: window.location.origin + "/logout-callback",
  response_type: "code",
  scope: config.scope,
  silent_redirect_uri: window.location.origin + "/silent-renew.html",
  automaticSilentRenew: true,
});
